export type Frequency = "Weekly" | "Daily" | "Monthly";

export type PlanStatus = "ACTIVE" | "STOP" | "MAINTAIN";

export type PlanScheduleStatus = "PENDING" | "PAID" | "TIMEOUT" | "FILLED";

export enum ScheduleType {
  AUTO = "auto",
  MANUAL = "manual"
}
